import React from 'react';
import { Select } from 'antd';
import { Form } from 'antd';
import { GlobalOutlinedIcon, LockIcon, UserIcon } from 'assets/icons/AntDeisgn_icons/iconStyle';
import {
  ForgotPasswordItem,
  InputWrap,
  RememberMe,
  SelectWrapper,
  StyledInput,
  StyledInputPassword,
  StyledLink,
  StyledSelectInput,
  ThemeLoginButton,
} from 'pages/login/login_style';

export default function ThumnailLogin({ buttonColor, buttonTextColor, theme }) {
  return (
    <div className='thumbnail_login-content-component'>
      <Form name='thumbnail_login' className='thumbnail_login-form-element'>
        <InputWrap className='thumbnail_login-input-wrapper'>
          <SelectWrapper className={`${theme} thumbnail_login-select-wrapper`}>
            <div className='prefix-icon-wrapper thumbnail_login-icon-wrap'>
              {<GlobalOutlinedIcon className='icon-color thumbnail_login-icon-color' />}
            </div>
            <Form.Item name='fqdn' className='thumbnail_login-form-item-fqdn'>
              <StyledSelectInput
                className={`${theme} thumbnail_login-selectorbox-fqdn`}
                size='large'
                placeholder='Select Domain'
              >
                <Select.Option value={''} className='thumbnail_login-selectorbox-option-fqdn'></Select.Option>
              </StyledSelectInput>
            </Form.Item>
          </SelectWrapper>

          <Form.Item name='username' className='thumbnail_login-form-item-username'>
            <StyledInput
              className={`${theme} thumbnail_login-input-username`}
              size='large'
              prefix={<UserIcon className='icon-color' />}
              placeholder='Username'
            />
          </Form.Item>
          <Form.Item name='password' className='thumbnail_login-form-item-password'>
            <StyledInputPassword
              className={`${theme} thumbnail_login-input-password`}
              size='large'
              prefix={<LockIcon className='icon-color' />}
              placeholder='Password'
            />
          </Form.Item>

          <p className='thumbnail_login-rememberMe-wrap'>
            <RememberMe className={`${theme} thumbnail_login-rememberMe-box`}>Remember me</RememberMe>
          </p>

          <Form.Item className='thumbnail_login-form-item-submit'>
            <ThemeLoginButton
              buttonColor={buttonColor}
              buttonTextColor={buttonTextColor}
              className={`${theme} thumbnail_login-submit-button`}
              type='primary'
            >
              Log in
            </ThemeLoginButton>
          </Form.Item>
          <ForgotPasswordItem className='thumbnail_login-form-item-forgot'>
            <StyledLink className={`${theme} thumbnail_login-forgot-link`}>Forgot Password ?</StyledLink>
          </ForgotPasswordItem>
        </InputWrap>
      </Form>
    </div>
  );
}
